// extracted by mini-css-extract-plugin
export var form = "_3x-0";